/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'student-general': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M93.09 486.26l84.527-51.432L512 636.928l334.383-202.1 84.526 51.432L512 739.84 93.09 486.26zm0-165.33L512 93.09l418.91 227.84L512 548.77 93.09 320.93zM512 828.045l334.383-202.147 84.526 51.479L512 930.909 93.09 677.376l84.527-51.48L512 828.045z" _fill="#2c2c2c"/>'
  }
})
